<template>
  <!-- Invoice Formula -->
  <b-tab :title="__('Invoice Formula')">
    <InvoiceFormula />
  </b-tab>
</template>

<script>
import InvoiceFormula from './Settings';

export default {
  components: {
    InvoiceFormula,
  },
};
</script>
